import React from 'react';

const cartInput = { width: '100%', background: '#0A0A0A', border: '1px solid rgba(201,168,76,0.25)', color: '#F5F5F0', padding: '11px 13px', fontSize: '13px', outline: 'none' };

const tipBtnStyle = (active) => ({
  fontSize: '13px', padding: '6px 12px', cursor: 'pointer',
  background: active ? '#C9A84C' : 'transparent',
  color: active ? '#0A0A0A' : '#C9A84C',
  border: '1px solid rgba(201,168,76,0.4)', fontWeight: active ? 600 : 400,
});

export const TipSelector = ({ tipPct, setTipPct, tipCustom, setTipCustom }) => (
  <div className="pt-2">
    <span className="font-body uppercase" style={{ fontSize: '10px', letterSpacing: '2px', color: '#C9A84C' }}>Propina (opcional)</span>
    <div className="flex flex-wrap gap-2 mt-2">
      {[0, 10, 15, 20].map((p) => (
        <button
          key={p}
          onClick={() => { setTipPct(p); setTipCustom(''); }}
          className="font-body"
          style={tipBtnStyle(tipPct === p)}
          data-testid={`tip-${p}`}
        >
          {p === 0 ? 'Sin propina' : `${p}%`}
        </button>
      ))}
      <button
        onClick={() => setTipPct('custom')}
        className="font-body"
        style={tipBtnStyle(tipPct === 'custom')}
        data-testid="tip-custom-btn"
      >
        Otra
      </button>
    </div>
    {tipPct === 'custom' && (
      <input
        type="number" min="0" step="0.50" placeholder="Monto de propina ($)"
        value={tipCustom}
        onChange={(e) => setTipCustom(e.target.value)}
        className="mt-2"
        style={cartInput}
        data-testid="tip-custom-input"
      />
    )}
  </div>
);
